// Bounce templates per language × category. Keep the brackets so the user
// fills them in — they should feel like solid scaffolding, not toys.

const TEMPLATES = {
  en: {
    code: "Act as a senior software engineer. Your task is to: [describe]. Constraints: [list].\nOutput format: [specify].",
    creative: "Act as a creative writer. Tone: [tone]. Length: [length].\nTopic: [topic]. Avoid: [list].",
    business: "Act as a business strategist. Goal: [goal]. Audience: [audience].\nDeliverable: [format]. Constraints: [list].",
    research: "Act as a research assistant. Topic: [topic]. Sources required: [yes/no — if yes, only use the provided context].\nOutput: structured summary with citations.",
    other: "Define your role: [role]. Task: [task]. Constraints: [list].\nOutput format: [format].",
  },
  es: {
    code: "Actúa como ingeniero de software senior. Tu tarea es: [describir]. Restricciones: [lista].\nFormato de salida: [especificar].",
    creative: "Actúa como escritor creativo. Tono: [tono]. Extensión: [longitud].\nTema: [tema]. Evita: [lista].",
    business: "Actúa como estratega de negocio. Objetivo: [objetivo]. Audiencia: [audiencia].\nEntregable: [formato]. Restricciones: [lista].",
    research: "Actúa como asistente de investigación. Tema: [tema]. ¿Requiere fuentes?: [sí/no — si sí, usa solo el contexto proporcionado].\nSalida: resumen estructurado con citas.",
    other: "Define tu rol: [rol]. Tarea: [tarea]. Restricciones: [lista].\nFormato de salida: [formato].",
  },
  hi: {
    code: "एक सीनियर सॉफ़्टवेयर इंजीनियर की भूमिका निभाएँ। आपका कार्य है: [विवरण]। बाधाएँ: [सूची]।\nआउटपुट प्रारूप: [निर्दिष्ट करें]।",
    creative: "एक रचनात्मक लेखक की भूमिका निभाएँ। टोन: [टोन]। लंबाई: [लंबाई]।\nविषय: [विषय]। टालें: [सूची]।",
    business: "एक व्यवसाय रणनीतिकार की भूमिका निभाएँ। लक्ष्य: [लक्ष्य]। दर्शक: [दर्शक]।\nडिलिवरेबल: [प्रारूप]। बाधाएँ: [सूची]।",
    research: "एक शोध सहायक की भूमिका निभाएँ। विषय: [विषय]। स्रोत आवश्यक हैं?: [हाँ/नहीं — यदि हाँ, केवल दिए गए संदर्भ का उपयोग करें]।\nआउटपुट: उद्धरणों के साथ संरचित सारांश।",
    other: "अपनी भूमिका परिभाषित करें: [भूमिका]। कार्य: [कार्य]। बाधाएँ: [सूची]।\nआउटपुट प्रारूप: [प्रारूप]।",
  },
};

export function getTemplate(language, category) {
  const lang = TEMPLATES[language] ? language : "en";
  return TEMPLATES[lang][category] || TEMPLATES[lang].other;
}

export const CATEGORIES = ["code", "creative", "business", "research", "other"];
